import React from 'react';
import { useIntl } from 'react-intl';

import { createStyles, MenuItem, TextField, Theme, Typography, withStyles } from '@material-ui/core';
import { StandardTextFieldProps } from '@material-ui/core/TextField';

import messages from './messages';

const styles = ({ spacing: { unit }, breakpoints: { down } }: Theme) =>
  createStyles({
    root: {
      flex: 1,
      display: 'flex',
      alignItems: 'center',

      [down('xs')]: {
        marginBottom: '32px',
        flexDirection: 'column',
        alignItems: 'flex-start',
      },
    },
    label: {
      marginRight: unit * 3,
    },
    textField: {
      minWidth: 240,
    },
  });

export type PcpMode = 'pcp' | 'team';

export enum PCPModeKeys {
  PCP = 'pcp',
  Team = 'team',
}

interface SelectPCPProps extends Omit<StandardTextFieldProps, 'onChange'> {
  classes: any;
  className?: string;
  onChange: (value: PcpMode) => void;
}

const SelectPCP = ({ classes, className, onChange, ...rest }: SelectPCPProps) => {
  const { formatMessage } = useIntl();

  return (
    <div className={classes.root}>
      <Typography variant="body1" className={classes.label}>
        {formatMessage(messages.label)}
      </Typography>
      <TextField
        className={classes.textField}
        select
        onChange={(event) => onChange(event.target.value as PcpMode)}
        {...rest}
      >
        <MenuItem value={PCPModeKeys.PCP}>{formatMessage(messages.modePCP)}</MenuItem>
        <MenuItem value={PCPModeKeys.Team}>{formatMessage(messages.modeTeam)}</MenuItem>
      </TextField>
    </div>
  );
};

export default withStyles(styles, { name: 'LumaSelectPCP' })(SelectPCP);
